import { AiAutomationConfig } from 'shared/api/requests/aiAutomation/schemas'

export enum LoaderStatus {
  NOT_LOADED = 'NOT_LOADED',
  LOADED = 'LOADED',
  DASHBOARD_LOADING = 'DASHBOARD_LOADING',
  INSTANT_ANSWERS_STATUS_UPDATING = 'INSTANT_ANSWERS_STATUS_UPDATING',
  SOCIAL_ENGAGEMENT_STATUS_UPDATING = 'SOCIAL_ENGAGEMENT_STATUS_UPDATING',
}

export interface AiAutomationCoreState {
  config: AiAutomationConfig
  loaderStatus: LoaderStatus
}
